<template>
	<div class="col-12">
		<div class="card card-outline card-info">
			<div class="card-header">
				<h3 class="card-title">Llenado de plan individual de mejora</h3>
			</div>
			<div class="card-body w-full" v-if="plan">
				<FillPlan :plan="plan || []"  v-if="!filled"></FillPlan>  
				<span v-else> Avance mensual guardado.</span>                   				
			</div>

			<div class="card-body w-full" v-else>
				<span > Hubo un problema, por favor regrese al menu principal.</span>                   				
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

import request from '../../services/request'
import FillPlan from '../../component/evaluations/FillPlan.vue';

export default {
	props: {
		id: {
		type: [ Number],
			required: true,
			default: 0,
		},
	},	
	name: "plan-fill",
	components: {
		FillPlan
	},
	data() {
		return {
			filled: false,
			plan: null,
		}
	},
	async mounted() {
		this.setHeaderTitle('Plan Individual');
		await this.fetchPlanCompetencies(this.id);
	},
	created() {
		Event.$on("event-load-profiles", () => {
			this.list();
		});
	},
	methods: {
		async fetchPlanCompetencies(planId) {
			this.loading = true;
			try {
				const { data } = await request.get(`/individual-plan/${planId}`);
				this.plan = data.data;
			} catch (error) {
				console.error("Error al obtener las competencias:", error);
			} finally {
				this.loading = false;
			}
		},
		async filledAutoEvaluation() {
			let service = request;
			let _endpoint = '/evaluations/mine';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					if (this.evaluation) {
						if (this.evaluation.type &&  this.evaluation.type == 'autoevaluation') {
								this.filled = data;							
						}
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
		})
	}
}
</script>

<style scoped>
.card-body{
	width: 100%;
	max-height: 75vh;
    overflow-y: overlay;
}
/* General */
* {
  scrollbar-color: #1d4745 #ffffff; /* Color del thumb y del fondo */
  scrollbar-width: thin; /* Ancho del scroll reducido */
}

/* Webkit */
::-webkit-scrollbar {
  width: 12px; /* Ancho del scroll vertical */
  height: 12px; /* Altura del scroll horizontal */
}

::-webkit-scrollbar-track {
  background: #ffffff; /* Fondo blanco del scroll */
  border-radius: 10px; /* Bordes redondeados del track */
  margin: 2px; /* Espaciado para evitar que el thumb toque los bordes */
}

::-webkit-scrollbar-thumb {
  background: #1d4745; /* Color del thumb */
  border-radius: 10px; /* Bordes redondeados del thumb */
  border: 2px solid #ffffff; /* Espaciado entre el thumb y el track */
}

::-webkit-scrollbar-thumb:hover {
  background: #14534f; /* Color más oscuro al pasar el mouse */
}




</style>
